/**
 * @flow
 */

import React from 'react'
import queryString from 'query-string'
import SuccessLogo from '../../../../Icons/SuccessLogo'
import {
  SuccessfulFormText,
  SuccessfulFormSubText,
  SuccessFormInnerContainer,
  SuccessfulFormInnerText
} from './styledComponents'

class SuccessFormMessage extends React.Component<Props> {
  queryParams = { arcades: '' }
  isBhowaniporePresentInQueryParams = () =>
    this.queryParams.arcades === 'bhowanipore'

  isVrCricketBhowaniporePresentInQueryParams = () =>
    this.queryParams.arcades === 'vr-cricket-bhowanipore'

  // renderSuccessText = () => {
  //   const { thankyouMessage } = this.props
  //   if (this.isVrCricketBhowaniporePresentInQueryParams()) {
  //     return 'We will call you shortly to have slots reserved for you.'
  //   } else if (this.isBhowaniporePresentInQueryParams()) {
  //     return 'You will receive a confirmation shortly'
  //   }
  //   return thankyouMessage
  // }

  render() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.queryParams = queryString.parse(window.location.search)
    }
    const { slotId, thankyouWishes, thankyouMessage } = this.props
    return (
      <SuccessFormInnerContainer>
        <SuccessLogo />
        <SuccessfulFormText>
          {thankyouWishes}
          <SuccessfulFormInnerText id="booking-id">{`BOOKING ID: ${slotId}`}</SuccessfulFormInnerText>
        </SuccessfulFormText>
        <SuccessfulFormSubText
          dangerouslySetInnerHTML={{
            __html: thankyouMessage
          }}
        />
      </SuccessFormInnerContainer>
    )
  }
}

export default SuccessFormMessage



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/SuccessFormMessage/index.js